<template>
  <ul class="project-links-list">
    <li
      :class="!!item.special && item.special == '1' ? 'item special' : 'item'"
      v-for="(item, index) of projectData.links"
      :key="index"
    >
      <a :href="item.url">
        <span class="iconfont icon-link"></span>
        <span class="text">{{item.desc}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ProjectLinks',
  props: {
    projectData: Object
  },
  data () {
    return {
      resourceUrl: this.$apiConfig.host
    }
  }
}
</script>

<style lang="scss" scoped>
.project-links-list {
  margin-top: 30px;
  .item {
    margin-bottom: 5px;
    .iconfont {
      display: inline-block;
      margin-right: 8px;
      color: rgba(217, 217, 214, .35);
    }
    .text {
      display: inline-block;
      border-bottom: 2px solid #fff;
      font-weight: bold;
      font-size: 1.2rem;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/project/components/ProjectLinks.vue